import { useCallback, useEffect, useRef, useState } from "react";
import { apiRequest } from "../../shared/api/client";
import type { Notify, SessionRow } from "./admin-types";
import { useAdminRequestScope } from "./useAdminRequestScope";

export function useAdminSessionsWorkspace({notify}: {notify: Notify}) {
  const scope = useAdminRequestScope(notify);
  const [rows, setRows] = useState<SessionRow[]>([]);
  const pending = useRef(new Set<string>());
  const load = useCallback(() => {
    if (!scope.isMounted()) return;
    const request = scope.beginRead();
    void apiRequest<SessionRow[]>("/api/admin/sessions").then(value => {
      if (scope.isCurrentRead(request)) setRows(value);
    }).catch((error: unknown) => {
      if (scope.isCurrentRead(request)) scope.notify(error instanceof Error ? error.message : "Oturumlar alınamadı.");
    });
  }, [scope]);
  useEffect(load, [load]);
  const revoke = async (row: SessionRow) => {
    if (!scope.isMounted() || pending.current.has(row.id)) return;
    pending.current.add(row.id);
    try {
      await apiRequest<void>(`/api/admin/sessions/${row.id}`, {method: "DELETE"});
      if (!scope.isMounted()) return;
      scope.invalidateReads();
      setRows(current => current.filter(item => item.id !== row.id));
      scope.notify(`${row.user_name} kullanıcısının oturumu sonlandırıldı.`);
    } catch (error) {
      scope.notify(error instanceof Error ? error.message : "Oturum sonlandırılamadı.");
    } finally {
      pending.current.delete(row.id);
    }
  };
  return {rows, load, revoke};
}
